export const APP_RUN = 'APP_RUN';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const COLOR_SCHEME_CHANGE = 'COLOR_SCHEME_CHANGE';

export const LOGIN = 'LOGIN';
export const PASSWORD_CONFIRM = 'PASSWORD_CONFIRM';
export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';
export const LOGOUT = 'LOGOUT';
export const SESSION_OVER_LOGOUT = 'SESSION_OVER_LOGOUT';
export const GET_PASSWORD_CHECK = 'GET_PASSWORD_CHECK';
export const LICENCE_CHECK = 'LICENCE_CHECK';

export const POST_SUBSCRIBE_NOTIFICATION = 'POST_SUBSCRIBE_NOTIFICATION';
export const POST_UNSUBSCRIBE_NOTIFICATION = 'POST_UNSUBSCRIBE_NOTIFICATION';
export const PUT_NOTIFICATION_OPTIONS = 'PUT_NOTIFICATION_OPTIONS';
export const GET_NOTIFICATION_OPTIONS = 'GET_NOTIFICATION_OPTIONS';
export const SET_NOTIFICATION_PERMISSION = 'SET_NOTIFICATION_PERMISSION';
export const SET_NOTIFICATION_SUBSCRIBED = 'SET_NOTIFICATION_SUBSCRIBED';
export const ALLOW_NOTIFICATION_PERMISSION = 'ALLOW_NOTIFICATION_PERMISSION';

export const GET_USER = 'GET_USER';
export const GET_COMPANY_INFO = 'GET_COMPANY_INFO';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const SAVE_BACK_URL = 'SAVE_BACK_URL';

export const GET_RESPONSIBLE_USERS = 'GET_RESPONSIBLE_USERS';
export const GET_PORTFOLIO_USERS = 'GET_PORTFOLIO_USERS';

export const GET_DOCUMENT = 'GET_DOCUMENT';
export const GET_DOCUMENT_INFO = 'GET_DOCUMENT_INFO';
export const PUT_DOCUMENT_TEXT = 'PUT_DOCUMENT_TEXT';
export const PUT_DOCUMENT_XML = 'PUT_DOCUMENT_XML';

export const GET_PROJECT = 'GET_PROJECT';
export const GET_PERSON = 'GET_PERSON';
export const GET_PROJECT_MASS = 'GET_PROJECT_MASS';

export const GET_PERSON_STATE_MENU = 'GET_PERSON_STATE_MENU';
export const PUT_PERSON_STATE = 'PUT_PERSON_STATE';

export const GET_COMPANY = 'GET_COMPANY';

export const CANCEL_REQUEST = 'CANCEL_REQUEST';
export const ADD_REQUEST = 'ADD_REQUEST';
export const ORGANIZATIONS = 'ORGANIZATIONS';
export const DEPARTMENT = 'DEPARTMENT';
export const LEGAL_ORGANIZATIONS = 'LEGAL_ORGANIZATIONS';
export const LEGAL_DEPARTMENT = 'LEGAL_DEPARTMENT';
export const LEGAL_DEPARTMENT_CELLS = 'LEGAL_DEPARTMENT_CELLS';
export const TOWNS = 'TOWNS';
export const REPLACING = 'REPLACING';
export const GET_EMPLOYEE = 'GET_EMPLOYEE';

export const GET_REQUEST_SETTINGS = 'GET_REQUEST_SETTINGS';
export const GET_REQUEST = 'GET_REQUEST';

export const GET_APPROVAL_PROJECT = 'GET_APPROVAL_PROJECT';
export const APPROVE_PROJECT = 'APPROVE_PROJECT';
export const REJECT_PROJECT = 'REJECT_PROJECT';

export const GET_APPROVAL_PROJECT_LIST = 'GET_APPROVAL_PROJECT_LIST';
export const SET_APPROVAL_PROJECT_LIST_SORT = 'SET_APPROVAL_PROJECT_LIST_SORT';
export const SET_APPROVAL_PROJECT_LIST_SELECTED = 'SET_APPROVAL_PROJECT_LIST_SELECTED';
export const SET_APPROVAL_PROJECT_LIST_PAGINATION = 'SET_APPROVAL_PROJECT_LIST_PAGINATION';
export const GET_APPROVAL_PROJECT_COUNTERS = 'GET_APPROVAL_PROJECT_COUNTERS';

export const GET_APPROVAL_PERSON = 'GET_APPROVAL_PERSON';
export const APPROVE_PERSON = 'APPROVE_PERSON';
export const REJECT_PERSON = 'REJECT_PERSON';

export const GET_APPROVAL_PERSON_LIST = 'GET_APPROVAL_PERSON_LIST';
export const SET_APPROVAL_PERSON_LIST_SORT = 'SET_APPROVAL_PERSON_LIST_SORT';
export const SET_APPROVAL_PERSON_LIST_SELECTED = 'SET_APPROVAL_PERSON_LIST_SELECTED';
export const SET_APPROVAL_PERSON_LIST_PAGINATION = 'SET_APPROVAL_PERSON_LIST_PAGINATION';
export const GET_APPROVAL_PERSON_COUNTERS = 'GET_APPROVAL_PERSON_COUNTERS';

export const GET_PROJECT_LIST = 'GET_PROJECT_LIST';
export const SET_PROJECT_LIST_FILTERS = 'SET_PROJECT_LIST_FILTERS';
export const SET_PROJECT_LIST_SORT = 'SET_PROJECT_LIST_SORT';
export const SET_PROJECT_LIST_PAGINATION = 'SET_PROJECT_LIST_PAGINATION';
export const SET_PROJECT_LIST_COLUMN_WIDTH = 'SET_PROJECT_LIST_COLUMN_WIDTH';
export const POST_PROJECT_LIST_COLUMN_WIDTH = 'POST_PROJECT_LIST_COLUMN_WIDTH';
export const GET_PROJECT_LIST_SETTINGS = 'GET_PROJECT_LIST_SETTINGS';
export const POST_PROJECT_LIST_SETTINGS = 'POST_PROJECT_LIST_SETTINGS';

export const GET_PROJECT_MASS_LIST = 'GET_PROJECT_MASS_LIST';
export const SET_PROJECT_MASS_LIST_FILTERS = 'SET_PROJECT_MASS_LIST_FILTERS';
export const SET_PROJECT_MASS_LIST_SORT = 'SET_PROJECT_MASS_LIST_FILTERS';
export const SET_PROJECT_MASS_LIST_PAGINATION = 'SET_PROJECT_MASS_LIST_PAGINATION';
export const SET_PROJECT_MASS_LIST_COLUMN_WIDTH = 'SET_PROJECT_MASS_LIST_COLUMN_WIDTH';
export const POST_PROJECT_MASS_LIST_COLUMN_WIDTH = 'POST_PROJECT_MASS_LIST_COLUMN_WIDTH';
export const POST_PROJECT_MASS_LIST_SETTINGS = 'POST_PROJECT_MASS_LIST_SETTINGS';
export const GET_PROJECT_MASS_LIST_SETTINGS = 'GET_PROJECT_MASS_LIST_SETTINGS';

export const GET_WORKSHEET_LIST = 'GET_WORKSHEET_LIST';
export const SET_WORKSHEET_LIST_FILTERS = 'SET_WORKSHEET_LIST_FILTERS';
export const SET_WORKSHEET_LIST_SORT = 'SET_WORKSHEET_LIST_SORT';
export const SET_WORKSHEET_LIST_SELECTED = 'SET_WORKSHEET_LIST_SELECTED';
export const SET_WORKSHEET_LIST_PAGINATION = 'SET_WORKSHEET_LIST_PAGINATION';
export const SET_WORKSHEET_LIST_COLUMN_WIDTH = 'SET_WORKSHEET_LIST_COLUMN_WIDTH';
export const POST_WORKSHEET_LIST_COLUMN_WIDTH = 'POST_WORKSHEET_LIST_COLUMN_WIDTH';
export const GET_WORKSHEET_LIST_SETTINGS = 'GET_WORKSHEET_LIST_SETTINGS';
export const POST_WORKSHEET_LIST_SETTINGS = 'POST_WORKSHEET_LIST_SETTINGS';

export const GET_WORKSHEET_MASS_LIST = 'GET_WORKSHEET_MASS_LIST';
export const SET_WORKSHEET_MASS_LIST_FILTERS = 'SET_WORKSHEET_MASS_LIST_FILTERS';
export const SET_WORKSHEET_MASS_LIST_SORT = 'SET_WORKSHEET_MASS_LIST_SORT';
export const SET_WORKSHEET_MASS_LIST_SELECTED = 'SET_WORKSHEET_MASS_LIST_SELECTED';
export const SET_WORKSHEET_MASS_LIST_SELECTED_STAGE = 'SET_WORKSHEET_MASS_LIST_SELECTED_STAGE';
export const SET_WORKSHEET_MASS_LIST_PAGINATION = 'SET_WORKSHEET_MASS_LIST_PAGINATION';
export const SET_WORKSHEET_MASS_LIST_COLUMN_WIDTH = 'SET_WORKSHEET_MASS_LIST_COLUMN_WIDTH';
export const POST_WORKSHEET_MASS_LIST_COLUMN_WIDTH = 'POST_WORKSHEET_MASS_LIST_COLUMN_WIDTH';
export const GET_WORKSHEET_MASS_LIST_SETTINGS = 'GET_WORKSHEET_MASS_LIST_SETTINGS';
export const POST_WORKSHEET_MASS_LIST_SETTINGS = 'POST_WORKSHEET_MASS_LIST_SETTINGS';

export const GET_REQUEST_LIST = 'GET_REQUEST_LIST';
export const GET_REQUEST_COUNTERS = 'GET_REQUEST_COUNTERS';
export const SET_REQUEST_LIST_SORT = 'SET_REQUEST_LIST_SORT';
export const SET_REQUEST_LIST_SELECTED = 'SET_REQUEST_LIST_SELECTED';
export const SET_REQUEST_LIST_PAGINATION = 'SET_REQUEST_LIST_PAGINATION';

export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_LOCK = 'SIDEBAR_LOCK';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';

export const OPEN_MODAL_PROJECT_SETTINGS = 'OPEN_MODAL_PROJECT_SETTINGS';
export const OPEN_MODAL_WORKSHEET_SETTINGS = 'OPEN_MODAL_WORKSHEET_SETTINGS';
export const OPEN_MODAL_PROJECT_MASS_SETTINGS = 'OPEN_MODAL_PROJECT_MASS_SETTINGS';
export const OPEN_MODAL_WORKSHEET_MASS_SETTINGS = 'OPEN_MODAL_WORKSHEET_MASS_SETTINGS';
export const OPEN_MODAL_DOCUMENT = 'OPEN_MODAL_DOCUMENT';
export const OPEN_MODAL_DOCUMENT_LINK = 'OPEN_MODAL_DOCUMENT_LINK';
export const OPEN_MODAL_DOCUMENT_VIEW = 'OPEN_MODAL_DOCUMENT_VIEW';
export const OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';
export const OPEN_MODAL_EVENT_CREATE = 'OPEN_MODAL_EVENT_CREATE';
export const OPEN_MODAL_EVENT_SCRIPT = 'OPEN_MODAL_EVENT_SCRIPT';
export const OPEN_MODAL_PERSON = 'OPEN_MODAL_PERSON';
export const OPEN_MODAL_STATE_PERSON = 'OPEN_MODAL_STATE_PERSON';
export const OPEN_MODAL_WORKSHEET_UNSUPPORTED = 'OPEN_MODAL_WORKSHEET_UNSUPPORTED';
export const OPEN_MODAL_REQUEST = 'OPEN_MODAL_REQUEST';
export const OPEN_MODAL_SOTRMEET_CREATE = 'OPEN_MODAL_SOTRMEET_CREATE';
export const OPEN_MODAL_SOTRMEET_UPDATE = 'OPEN_MODAL_SOTRMEET_UPDATE';
export const OPEN_MODAL_TASK_CREATE = 'OPEN_MODAL_TASK_CREATE';
export const OPEN_MODAL_TASK_UPDATE = 'OPEN_MODAL_TASK_UPDATE';
export const OPEN_MODAL_PROJECT = 'OPEN_MODAL_PROJECT';
export const OPEN_MODAL_MASS_STAGE = 'OPEN_MODAL_MASS_STAGE';
export const OPEN_CUSTOM_PUSH_PERMISSION = 'OPEN_CUSTOM_PUSH_PERMISSION';
export const OPEN_MODAL_SCENARIO_TEST = 'OPEN_MODAL_SCENARIO_TEST';
export const OPEN_MODAL_SCENARIO = 'OPEN_MODAL_SCENARIO';
export const OPEN_MODAL_COMPANY = 'OPEN_MODAL_COMPANY';
export const OPEN_MODAL_CANCEL_REQUEST = 'OPEN_MODAL_CANCEL_REQUEST';
export const OPEN_MODAL_APPROVE_PERSON = 'OPEN_MODAL_APPROVE_PERSON';
export const OPEN_MODAL_REJECT_PERSON = 'OPEN_MODAL_REJECT_PERSON';
export const OPEN_MODAL_APPROVE_PROJECT = 'OPEN_MODAL_APPROVE_PROJECT';
export const OPEN_MODAL_REJECT_PROJECT = 'OPEN_MODAL_REJECT_PROJECT';

export const OPEN_MODAL_CONFIRM = 'OPEN_MODAL_CONFIRM';

export const OPEN_MODAL_CREATE_APPLICATION = 'OPEN_MODAL_CREATE_APPLICATION';

export const OPEN_MODAL_EDUCATION_EVENT = 'OPEN_MODAL_EDUCATION_EVENT';

export const OPEN_MODAL_AVATAR = 'OPEN_MODAL_AVATAR';

export const OPEN_MODAL_TRAINER_MARK = 'OPEN_MODAL_TRAINER_MARK';

export const OPEN_MODAL_SCORM = 'OPEN_MODAL_SCORM';

export const OPEN_MODAL_SCENARIO_BOOK = 'OPEN_MODAL_SCENARIO_BOOK';

export const CLOSE_MODAL = 'CLOSE_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';

export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const GET_EVENT = 'GET_EVENT';
export const GET_EVENT_TYPES = 'GET_EVENT_TYPES';
export const GET_AVAILABLE_EVENTS = 'GET_AVAILABLE_EVENTS';
export const GET_EVENT_DICTIONARIES = 'GET_EVENT_DICTIONARIES';
export const GET_YES_NO = 'GET_YES_NO';
export const GET_SCRIPT = 'GET_SCRIPT';
export const GET_PARTICIPANTS = 'GET_PARTICIPANTS';

export const GET_MENU_COUNTERS = 'GET_MENU_COUNTERS';

export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';

export const PIN_LEFT_MENU = 'PIN_LEFT_MENU';
export const COLLAPSE_LEFT_MENU = 'COLLAPSE_LEFT_MENU';

export const POST_EMAIL_APPROVAL = 'POST_EMAIL_APPROVAL';

export const GET_NOTDONE_LIST = 'GET_NOTDONE_LIST';
export const SET_NOTDONE_LIST_SELECTED = 'SET_NOTDONE_LIST_SELECTED';
export const SET_NOTDONE_LIST_SORT = 'SET_NOTDONE_LIST_SORT';
export const SET_NOTDONE_LIST_PAGINATION = 'SET_NOTDONE_LIST_PAGINATION';

export const GET_CALENDAR = 'GET_CALENDAR';
export const GET_CALENDAR_USERS = 'GET_CALENDAR_USERS';
export const CHANGE_CALENDAR_PERIOD = 'CHANGE_CALENDAR_PERIOD';
export const CHANGE_CALENDAR_TASK_VIEW = 'CHANGE_CALENDAR_TASK_VIEW';
export const CREATE_SOTRMEET = 'CREATE_SOTRMEET';
export const UPDATE_SOTRMEET = 'UPDATE_SOTRMEET';
export const CREATE_TASK = 'CREATE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const GET_EDUCATION_TIMESHEET = 'GET_EDUCATION_TIMESHEET';
export const GET_TRAINER_TIMESHEET = 'GET_TRAINER_TIMESHEET';

export const GET_DICTIONARY = 'GET_DICTIONARY';
export const GET_FIELD_DICTIONARY = 'GET_FIELD_DICTIONARY';

export const GET_MASS_STAGES = 'GET_MASS_STAGES';

export const POST_MASS_STAGE_MENU = 'POST_MASS_STAGE_MENU';
export const POST_MASS_STAGE = 'POST_MASS_STAGE';

export const CLOSE_ALL_COLLAPSIBLE = 'CLOSE_ALL_COLLAPSIBLE';
export const SET_COLLAPSIBLE_ACTIVE = 'SET_COLLAPSIBLE_ACTIVE';
export const COLLAPSE_MODALS = 'COLLAPSE_MODALS';
export const CLOSE_COLLAPSIBLE = 'CLOSE_COLLAPSIBLE';
export const AFTER_CLOSE_COLLAPSIBLE = 'AFTER_CLOSE_COLLAPSIBLE';
export const REMOVE_ALL_COLLAPSIBLE = 'REMOVE_ALL_COLLAPSIBLE';
export const SHOW_COLLAPSIBLE = 'SHOW_COLLAPSIBLE';

export const GET_ACTION_VACANCY_LIST = 'GET_ACTION_VACANCY_LIST';
export const GET_ACTION_VACANCY = 'GET_ACTION_VACANCY';
export const OPEN_MODAL_ACTION_VACANCY = 'OPEN_MODAL_ACTION_VACANCY';

export const GET_APPROVAL_APPLICATION_LIST = 'GET_APPROVAL_APPLICATION_LIST';
export const GET_APPROVAL_APPLICATION_LIST_COUNTERS = 'GET_APPROVAL_APPLICATION_LIST_COUNTERS';
export const GET_APPROVAL_APPLICATION = 'GET_APPROVAL_APPLICATION';
export const PUT_APPROVAL_APPLICATION = 'PUT_APPROVAL_APPLICATION';
export const OPEN_MODAL_APPLICATION_CANCEL = 'OPEN_MODAL_APPLICATION_CANCEL';
export const OPEN_MODAL_APPLICATION_APPROVE = 'OPEN_MODAL_APPLICATION_APPROVE';

export const GET_APPLICATION_LIST = 'GET_APPLICATION_LIST';
export const GET_APPLICATION = 'GET_APPLICATION';
export const POST_APPLICATION = 'POST_APPLICATION';

export const GET_COURSES_LIST = 'GET_COURSES_LIST';
export const GET_ACTION_LIST = 'GET_ACTION_LIST';
export const GET_ACTION = 'GET_ACTION';

export const POST_LINK_REGISTRATION = 'POST_LINK_REGISTRATION';
export const GET_LOGIN_INFO = 'GET_LOGIN_INFO';

export const POST_AVATAR = 'POST_AVATAR';

export const GET_COURSE_LIST = 'GET_COURSE_LIST';
export const GET_COURSE = 'GET_COURSE';

export const GET_SCENARIO_AUTH = 'GET_SCENARIO_AUTH';
export const GET_SCENARIO = 'GET_SCENARIO';

export const GET_SCENARIO_TEST = 'GET_SCENARIO_TEST';
export const POST_SCENARIO_TEST = 'POST_SCENARIO_TEST';

export const GET_TRAINER_EVENTS = 'GET_TRAINER_EVENTS';
export const PUT_TRAINER_MARKS = 'PUT_TRAINER_MARKS';

export const PUT_ENROLL_COURSE = 'PUT_ENROLL_COURSE';

export const GET_NEWS_LIST = 'GET_NEWS_LIST';
export const GET_NEWS = 'GET_NEWS';

export const PUT_SCENARIO_BOOK_READ = 'PUT_SCENARIO_BOOK_READ';
export const GET_SCENARIO_BOOK = 'GET_SCENARIO_BOOK';

export const GET_SCENARIO_FILE_LIST = 'GET_SCENARIO_FILE_LIST';

export const POST_METRO_REQUEST = 'POST_METRO_REQUEST';
export const POST_METRO_REQUEST_DOCUMENT = 'POST_METRO_REQUEST_DOCUMENT';
export const POST_METRO_REQUEST_ROUTE = 'POST_METRO_REQUEST_ROUTE';
export const GET_METRO_REQUESTS = 'GET_METRO_REQUESTS';
export const GET_METRO_REQUEST = 'GET_METRO_REQUEST';

export const GET_METRO_POSITION = 'GET_METRO_POSITION';
export const GET_METRO_CHIEF = 'GET_METRO_CHIEF';
export const GET_METRO_COST = 'GET_METRO_COST';
export const GET_METRO_FUNCTION = 'GET_METRO_FUNCTION';

export const OPEN_MODAL_METRO_REQUEST_ROUTE = 'OPEN_MODAL_METRO_REQUEST_ROUTE';
export const OPEN_MODAL_METRO_REQUEST_POSITION = 'OPEN_MODAL_METRO_REQUEST_POSITION';
export const OPEN_MODAL_METRO_REQUEST_APPROVE = 'OPEN_MODAL_METRO_REQUEST_APPROVE';
export const OPEN_MODAL_METRO_REQUEST_REJECT = 'OPEN_MODAL_METRO_REQUEST_REJECT';
export const OPEN_MODAL_METRO_REQUEST_CANCEL = 'OPEN_MODAL_METRO_REQUEST_CANCEL';
export const POST_METRO_REQUEST_APPROVAL = 'POST_METRO_REQUEST_APPROVAL';

export const GET_METRO_DEPARTMENTS = 'GET_METRO_DEPARTMENTS';
export const GET_METRO_DEPARTMENT_CHILDREN = 'GET_METRO_DEPARTMENT_CHILDREN';

export const GET_METRO_DOCUMENT = 'GET_METRO_DOCUMENT';

export const GET_METRO_AUTH = 'GET_METRO_AUTH';
export const GET_METRO_REQUEST_LINK = 'GET_METRO_REQUEST_LINK';
